import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizePreClaimsDocumentTypes } from './normalize';

export const fetchPreClaimsDocumentTypes = createProvider(api.fetchPreClaimsDocumentTypes)
  .andThen((res) => normalizePreClaimsDocumentTypes(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
